"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Workers = void 0;
const validation_worker_1 = __importDefault(require("worker-loader!./validation.worker"));
const ValidationWorker = new validation_worker_1.default();
class Workers {
    static validate(code, libraries) {
        return new Promise((resolve) => {
            ValidationWorker.postMessage({ code, libraries });
            ValidationWorker.addEventListener('message', (message) => {
                resolve(message.data);
            });
        });
    }
}
exports.Workers = Workers;
